import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import {
  pageResetMiddleWare,
  zodOptionalDateRange,
  zodOptionalIdArray,
  zodPage,
} from 'routes/routeUtils';
import { z } from 'zod';

const labTradesInstancesStatusSchema = z.array(
  z.enum(['awaiting_validation_by_lab', 'validated_by_lab', 'refused_by_lab', 'paid'])
);

export const labTradesInstancesSearchSchema = z.object({
  tab: z
    .enum([
      'awaiting_validation_by_lab',
      'validated_by_lab',
      'refused_by_lab',
      'paid',
      'subscribed',
      'awaiting_validation_by_faks',
      'all',
    ])
    .default('all'),
  status: labTradesInstancesStatusSchema.optional(),
  page: zodPage,
  groupIds: zodOptionalIdArray,
  transmittedAtRange: zodOptionalDateRange,
  validatedRefusedAtRange: zodOptionalDateRange,
  compensatedAtRange: zodOptionalDateRange,
  pharmacyIds: zodOptionalIdArray,
  minCompensation: z.number().optional(),
  tradeIds: zodOptionalIdArray,
  hasStripeConnected: z.boolean().optional(),
  salesRepIds: zodOptionalIdArray,
  regionalDirectorIds: zodOptionalIdArray,
});

export type LabTradesInstancesSearchType = z.infer<typeof labTradesInstancesSearchSchema>;

export const labTradesInstancesRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/trades/list',
  validateSearch: labTradesInstancesSearchSchema,
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/lab/Trades/LabTradeInstances/LabTradeInstancesPage/LabTradeInstancesPage').then(
    (d) => d.Route
  )
);
